import React from "react";
import { LocationInput } from "tsi-common-react/src/apps/common/containers/LocationInput";
import { t } from "ttag";

interface IProps {
    onSubmit?: () => void;
}

export const LocatorSearch = (props: IProps): React.ReactNode => {
    const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
    };

    const locationInputID = "location-autocomplete";
    return (
        <form className="form form--locator" onSubmit={onSubmit}>
            <fieldset>
                <legend className="filters__instruct">
                    {t`Change your location to find retailers in that area.`}
                </legend>
                <div className="form__field filters__inputs">
                    <div className="form__input">
                        <label
                            htmlFor={locationInputID}
                            className="ada-screenreader-only"
                        >
                            {t`Location`}
                        </label>
                        {/* TODO(i18n): Use t tagged template for placeholder: placeholder: t`Enter address, city, state or zip` */}
                        <LocationInput
                            inputProps={{
                                id: locationInputID,
                                placeholder:
                                    "Enter address, city, state or zip",
                            }}
                            inputFormat="long"
                            onAfterChange={props.onSubmit}
                        />
                    </div>
                </div>
                <div className="filters__actions">
                    {/* TODO(i18n): Use t tagged template for aria-label: aria-label={t`Search`} */}
                    <button
                        className="button filters__button"
                        type="submit"
                        aria-label="Search"
                    ></button>
                </div>
            </fieldset>
        </form>
    );
};
